export default __webpack_public_path__ + "static/avatar-mp-kayi-male-0-v4-cover-7cb3d0271d25f118e8c0c2bdcbb4af27.png";